/** 首页「核心价值」图标：由 webpack 解析为可访问 URL */
const ICON_BY_FILE = {
  "1.jpg": require("@/static/icon/1.jpg"),
  "2.jpg": require("@/static/icon/2.jpg"),
  "3.jpg": require("@/static/icon/3.jpg"),
  "4.png": require("@/static/icon/4.png")
};

/**
 * 将接口 / mock 中的 icon 字段转为可用图片地址。
 * 支持：完整 http(s)、已打包路径、以及历史数据里的 `@/static/icon/x.jpg` 形式。
 */
export function resolveCoreValueIcon(icon) {
  if (icon == null || icon === "") return "";
  const s = String(icon).trim();
  if (/^https?:\/\//i.test(s)) return s;
  if (s.startsWith("/") && !s.includes("@")) return s;
  const base = s.replace(/^.*[/\\]/, "");
  if (ICON_BY_FILE[base]) return ICON_BY_FILE[base];
  return s;
}
